import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";

import Button, { BUTTON_WIDTH } from "@gc-npm/components.button";
import CustomLink from "@gc-npm/components.custom-link";
import Glyph from "@gc-npm/components.icon-glyph";
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
} from "@gc-npm/components.text";
import { COLORS } from "@gc-npm/utils.enums.colors";
import sendGaEvent from "@gc-npm/utils.metrics.send-ga-event";

const COMPONENT_NAME = 'employee-Modal'

const EmployeeModal = ({ title, description, button }) => {
  const dispatch = useDispatch();

   const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentProduct: "",
    componentContent: 'imprime-empleados',
    componentVariation: "",
  };

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: "print-success",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: "",
      })
    );
  };
  return (
    <div className="EmployeeModal">
      <div className="modal__close">
        <CustomLink
          ariaLabel="Cerrar"
          taggingInfo={{ ...taggingInfo, componentContent: "Cerrar" }}
          onClick={onCloseModal}
        >
          <Glyph
            id="cerrar"
            height={20}
            width={20}
            color={TEXT_COLOR.MOVISTAR_BLUE}
          />
        </CustomLink>
      </div>
      {title?.text && (
        <TextInfo
          text={title.text}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.MOVISTAR_BLACK}
          size={TEXT_SIZE.BODY1}
          align={TEXT_ALIGN.LEFT}
          fontType={TEXT_FONT_WEIGHT.BOLD}
        />
      )}

      {description?.text && (
        <TextInfo
          text={description.text}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.GREY5}
          size={TEXT_SIZE.BODY2}
          align={TEXT_ALIGN.LEFT}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
      )}

      {button?.label && (
        <div className="modal__button">
          <Button
            label={button.label}
            href={button.href}
            width={BUTTON_WIDTH.SHORT}
            taggingInfo={{ componentName: COMPONENT_NAME, componentContent: button.label }}
            forceExternal
          />
        </div>
      )}

      <style jsx>{`
        .EmployeeModal {
          background-color: ${COLORS.white};
          padding: 1.5rem;
          border-radius: 16px;
          width: 560px;
          max-width: calc(100vw - 2rem);
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .modal__close {
          display: flex;
          justify-content: flex-end;
        }
        .modal__button {
          align-self: flex-start;
        }
      `}</style>
    </div>
  );
};
export default EmployeeModal;
